import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles, permission }) {
  const { user, loading, hasPerm } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="h-10 w-10 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // FIX 11: Admin/cashier hitting dashboard → redirect to /bills (operations screen)
  const fallback = user.role === "super_admin" ? "/" : "/bills";
  if (roles && !roles.includes(user.role)) return <Navigate to={fallback} replace />;
  if (permission && !hasPerm(permission)) return <Navigate to={fallback} replace />;
  return children;
}
